export default "__VITE_ASSET__BXZG0xQO__"